import { RSAA } from 'redux-api-middleware';
import { get, find } from 'lodash';
import { getBeneficiaryCreateRequest } from '../../helpers/apiRequestBuilder/';
import endpoints from '../../utils/endpoints';
import { getBankId } from '../../states/session/selectors';

export const SET_PAYEES = 'SET_PAYEES';
export const REMOVE_PAYEE = 'REMOVE_PAYEE';

export const BENEFICIARY_CREATE_REQUEST = 'BENEFICIARY_CREATE_REQUEST';
export const BENEFICIARY_CREATE_SUCCESS = 'BENEFICIARY_CREATE_SUCCESS';
export const BENEFICIARY_CREATE_FAILURE = 'BENEFICIARY_CREATE_FAILURE';

export const GET_ALL_BENEFICIARIES_REQUEST = 'GET_ALL_BENEFICIARIES_REQUEST';
export const GET_ALL_BENEFICIARIES_SUCCESS = 'GET_ALL_BENEFICIARIES_SUCCESS';
export const GET_ALL_BENEFICIARIES_FAILURE = 'GET_ALL_BENEFICIARIES_FAILURE';

export const GET_BENEFICIARY_DETAILS_BY_ID_REQUEST = 'GET_BENEFICIARY_DETAILS_BY_ID_REQUEST';
export const GET_BENEFICIARY_DETAILS_BY_ID_SUCCESS = 'GET_BENEFICIARY_DETAILS_BY_ID_SUCCESS';
export const GET_BENEFICIARY_DETAILS_BY_ID_FAILURE = 'GET_BENEFICIARY_DETAILS_BY_ID_FAILURE';

export const GET_PAYEE_SRD_CHECK_REQUEST = 'GET_PAYEE_SRD_CHECK_REQUEST';
export const GET_PAYEE_SRD_CHECK_SUCCESS = 'GET_PAYEE_SRD_CHECK_SUCCESS';
export const GET_PAYEE_SRD_CHECK_FAILURE = 'GET_PAYEE_SRD_CHECK_FAILURE';

export const SET_DUPLICATE_PAYEE_SUBMITTED = 'SET_DUPLICATE_PAYEE_SUBMITTED';
export const REMOVE_DUPLICATE_PAYEE_SUBMITTED = 'REMOVE_DUPLICATE_PAYEE_SUBMITTED';

export const SET_ACCOUNT_ERROR = 'SET_ACCOUNT_ERROR';
export const UNSET_ACCOUNT_ERROR = 'UNSET_ACCOUNT_ERROR';

export const SET_TEMPLATE_ERROR = 'SET_TEMPLATE_ERROR';
export const UNSET_TEMPLATE_ERROR = 'UNSET_TEMPLATE_ERROR';

export const SET_ACCOUNT_NAME_SERVICES_ERROR = 'SET_ACCOUNT_NAME_SERVICES_ERROR';
export const UNSET_ACCOUNT_NAME_SERVICES_ERROR = 'UNSET_ACCOUNT_NAME_SERVICES_ERROR';

export const setPayees = (payees) => ({
	type: SET_PAYEES,
	payees,
});
export const removePayee = (payeeId) => ({
	type: REMOVE_PAYEE,
	payeeId,
});

export const submitBeneficiaries = (bankId, payments, accounts) => {
	const body = JSON.stringify({
		batch_list: payments.map((payment) =>
			getBeneficiaryCreateRequest(bankId)({
				...payment,
				displayName: get(
					find(accounts, (account) => payment.toAccount === account.id),
					'displayName'
				),
			})
		),
	});

	return (dispatch) =>
		dispatch({
			[RSAA]: {
				endpoint: endpoints.multipart.uri,
				method: 'POST',
				types: [BENEFICIARY_CREATE_REQUEST, BENEFICIARY_CREATE_SUCCESS, BENEFICIARY_CREATE_FAILURE],
				body,
				headers: { 'x-bpi-version': endpoints.multipart.x_bpi_version },
			},
		});
};

export const getAllBeneficiaries = (bankId) => {
	const endpoint = endpoints.getAllBeneficiaries.resolve(bankId);
	return {
		[RSAA]: {
			endpoint,
			method: 'GET',
			types: [GET_ALL_BENEFICIARIES_REQUEST, GET_ALL_BENEFICIARIES_SUCCESS, GET_ALL_BENEFICIARIES_FAILURE],
			headers: { 'x-bpi-version': endpoints.getAllBeneficiaries.x_bpi_version },
		},
	};
};

export const getBeneficiaryDetailsById = (beneficiaryId) => {
	const endpoint = endpoints.getBeneficiaryById.resolve(beneficiaryId);
	const { method, x_bpi_version } = endpoints.getBeneficiaryById;
	return {
		[RSAA]: {
			endpoint,
			method,
			types: [
				GET_BENEFICIARY_DETAILS_BY_ID_REQUEST,
				GET_BENEFICIARY_DETAILS_BY_ID_SUCCESS,
				GET_BENEFICIARY_DETAILS_BY_ID_FAILURE,
			],
			headers: { 'x-bpi-version': x_bpi_version },
		},
	};
};

export const getPayeeSrdCheckRequest = ({ bankId, scopeId, sortCodeAccountNumber }) => {
	const endpoint = endpoints.getSrdVerification.resolve(bankId, scopeId);
	const { method, x_bpi_version } = endpoints.getSrdVerification;
	const body = {
		scheme_name: 'SortCodeAccountNumber',
		identification: sortCodeAccountNumber,
	};

	return {
		[RSAA]: {
			endpoint,
			method,
			types: [GET_PAYEE_SRD_CHECK_REQUEST, GET_PAYEE_SRD_CHECK_SUCCESS, GET_PAYEE_SRD_CHECK_FAILURE],
			headers: { 'x-bpi-version': x_bpi_version },
			body: JSON.stringify(body),
		},
	};
};

export const getPayeeSrdCheck = (sortCodeAccountNumber) => (dispatch, getState) => {
	const state = getState();
	const bankId = getBankId(state);
	const scopeId = 'default';

	return dispatch(getPayeeSrdCheckRequest({ bankId, scopeId, sortCodeAccountNumber }));
};

export const setDuplicatePayeeSubmitted = () => ({
	type: SET_DUPLICATE_PAYEE_SUBMITTED,
});

export const removeDuplicatePayeeSubmitted = () => ({
	type: REMOVE_DUPLICATE_PAYEE_SUBMITTED,
});

export const setAccountError = (payload) => ({
	type: SET_ACCOUNT_ERROR,
	payload: payload,
});

export const unsetAccountError = () => ({
	type: UNSET_ACCOUNT_ERROR,
});

export const setTemplateError = (templateError) => ({
	type: SET_TEMPLATE_ERROR,
	payload: templateError,
});

export const unsetTemplateError = () => ({
	type: UNSET_TEMPLATE_ERROR,
});

export const setAccountNameServicesError = () => ({
	type: SET_ACCOUNT_NAME_SERVICES_ERROR,
});

export const unsetAccountNameServicesError = () => ({
	type: UNSET_ACCOUNT_NAME_SERVICES_ERROR,
});
